interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function LoadingSpinner({ size = "md", className = "" }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "w-12 h-12 md:w-16 md:h-16",
    md: "w-[70px] h-[70px] md:w-24 md:h-24",
    lg: "w-24 h-24 md:w-32 md:h-32",
  };

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <style>{`
        @keyframes fadeInOut {
          0%, 100% { opacity: 0.15; }
          50% { opacity: 1; }
        }
        
        .logo-element-1 { animation: fadeInOut 3s ease-in-out infinite; }
        .logo-element-2 { animation: fadeInOut 3s ease-in-out infinite 0.4s; }
        .logo-element-3 { animation: fadeInOut 3s ease-in-out infinite 0.8s; }
        .logo-element-4 { animation: fadeInOut 3s ease-in-out infinite 1.2s; }
        .logo-element-5 { animation: fadeInOut 3s ease-in-out infinite 1.6s; }
      `}</style>

      <svg
        viewBox="0 0 1267.5 1267.5"
        className={`${sizeClasses[size]} fill-current`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <style>{`.c{fill:#2146ce;stroke:#221f20;stroke-miterlimit:10;stroke-width:.4px;}`}</style>
        </defs>
        
        {/* Element 1 */}
        <path
          className="logo-element-1 c"
          d="M205.3,165.2l589.7,590.5c1.8,1.8,1.8,4.7,0,6.4l-332.9,332.1c-3,3-8.2.9-8.2-3.4v-228.4c0-1.2-.5-2.4-1.3-3.2l-256.3-256.3V168.9c0-4.7,5.7-7.1,9-3.7Z"
        />
        
        {/* Element 2 */}
        <path
          className="logo-element-2 c"
          d="M207.2,866h205.2c2.5,0,4.6,2,4.6,4.6v205.2c0,4.1-4.9,6.1-7.8,3.2l-205.2-205.2c-2.9-2.9-.8-7.8,3.2-7.8Z"
        />
        
        {/* Element 3 */}
        <path
          className="logo-element-3 c"
          d="M958,168.5v430.7l-133.2,132.8-223.3-222.7,347.4-344.5c3.3-3.3,9-.9,9,3.8Z"
        />
        
        {/* Element 4 */}
        <path
          className="logo-element-4 c"
          d="M947.3,891.7l-346.3,130.5c-5.5,2.1-10-4.8-5.8-9l276.3-276.1c3.9-3.9,9.8-4.8,14.6-2.3l127.1,65.3c28.4,14.6,50.3,39.3,61.5,69.2l11.7,31.5c1.7,4.6-3.1,8.9-7.5,6.7l-19.8-10c-34.8-17.5-75.3-19.6-111.8-5.9Z"
        />
        
        {/* Element 5 - Line */}
        <line
          className="logo-element-5 c"
          x1="442.1"
          y1="402.3"
          x2="731.1"
          y2="691.8"
        />
      </svg>
    </div>
  );
}
